import React from 'react';
import { AlertCircle } from 'lucide-react';

/**
 * Mensaje de error inline bajo un campo de formulario.
 * Renderiza nada si `message` es vacío, así puede colocarse siempre.
 */
export const FieldError = ({ message, testid }) => {
  if (!message) return null;
  return (
    <p
      className="mt-1 text-xs text-rose-600 flex items-center gap-1"
      role="alert"
      data-testid={testid}
    >
      <AlertCircle className="w-3 h-3 shrink-0" />
      {message}
    </p>
  );
};

export default FieldError;
